'use strict';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion';
import {
  ReduxListFilterStreamedContainer,
  ReduxListStreamedContainer,
} from '../../../core-utilities/redux/ReduxListContainer';
import {componentOptions, reduxList} from '../../../requirements/redux/projectReqList';
import {TaskType} from '../../enums/TaskType';
import {projectTasksCtrlConfig} from '../../router-project-tasks';
import {TaskViewRequirementsComponent} from './TaskViewRequirementsComponent';
import {TaskViewRequirementsContainer} from './TaskViewRequirementsContainer';


const StreamedComponent = TaskViewRequirementsContainer({
  taskType: TaskType.PROJECT,
  taskListState: projectTasksCtrlConfig.taskListState,
});

const ListComponent = ReduxListStreamedContainer(
  TaskViewRequirementsComponent,
  reduxList,
  componentOptions,
);
const FilterComponent = ReduxListFilterStreamedContainer(
  ListComponent,
  reduxList,
  componentOptions,
);
export const ProjectTaskViewRequirementsContainer = fuse(StreamedComponent)(FilterComponent);



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskViewRequirements/ProjectTaskViewRequirementsContainer.js